import installationInstructions from './installationInstructions';

const ariaNmContent = {
  installationInstructions
}

export { ariaNmContent };